module.exports = __webpack_public_path__ + "static/media/rl-logo.2adb5606.png";